import { createStore } from "vuex";

export default createStore({
  state: {
    UAVList: null,
    checkedUAV: {
      planeId: "BY614124110013",
      lon: 116.709805,
      lat: 35.411897,
      planeType: "",
    },
    mqttUAVData: null,
    user: null,
  },
  mutations: {
    updateUAVList(state, payload) {
      state.UAVList = payload;
    },
    updateCheckedUAV(state, payload) {
      state.checkedUAV = payload;
    },
    updateMqttUAVData(state, payload) {
      state.mqttUAVData = payload;
    },
    updateUser(state, payload) {
      state.user = payload;
    },
  },
  actions: {},
  modules: {},
});
